import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RandomScreeningDriverSelection extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  randomScreeningPeriodId: number;

  @autoserialize
  complete: boolean;

  @autoserializeAs(Date)
  completedAt: Date;

  @autoserialize
  refused: boolean;

  @autoserialize
  refusalReasonNote: string;

  @autoserialize
  refusalReasonId: number;

  @autoserializeAs(Date)
  notifiedAt: Date;

  @autoserialize
  notificationReceived: boolean;

  @autoserializeAs(Date)
  notificationReceivedAt: Date;

  @autoserialize
  screeningId: number;

  @autoserialize
  notified: boolean;

  static OnSerialized(instance: RandomScreeningDriverSelection, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.completedAt)) {
      json.completedAt = DateUtil.serializeInstant(instance.completedAt);
    }

    if (!isNullOrUndefined(instance.notifiedAt)) {
      json.notifiedAt = DateUtil.serializeInstant(instance.notifiedAt);
    }

    if (!isNullOrUndefined(instance.notificationReceivedAt)) {
      json.notificationReceivedAt = DateUtil.serializeInstant(instance.notificationReceivedAt);
    }
  }

  static OnDeserialized(instance: RandomScreeningDriverSelection, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['completedAt'])) {
      instance.completedAt = DateUtil.deserializeLocalDate(json['completedAt']);
    }

    if (!isNullOrUndefined(json['notifiedAt'])) {
      instance.notifiedAt = DateUtil.deserializeLocalDate(json['notifiedAt']);
    }

    if (!isNullOrUndefined(json['notificationReceivedAt'])) {
      instance.notificationReceivedAt = DateUtil.deserializeLocalDate(json['notificationReceivedAt']);
    }
  }
}
